import React from 'react';
import AuxiliaryText from '../../components/common/Typography/AuxiliaryText';
import Paragraph from '../../components/common/Typography/Paragraph';

export const BusinessInfo = ({ userData }) => {
  // Get plan name from userData, default to "Basic"
  const planName = userData?.userPlan?.plan?.name || 'Basic';
  const displayPlan = `TradesPoster ${planName}`;

  return (
    <div className="flex flex-col gap-6">

      {/* <div className="bg-white rounded-xl py-5 px-8">
        <div className="flex items-center gap-5 text-offblack">
          <i className="fi fi-sr-badge text-base flex items-center"></i>
          <Paragraph variant={"BodyCompact"}>ABN: 12 345 678 901</Paragraph>
        </div>
      </div> */}

      {/* Phone Number Container */}
      <div className="bg-white rounded-xl py-5 px-8">
        {/* <div className="flex flex-col gap-3"> */}
          <div className="flex items-center gap-3 text-offblack">
            <i className="fi fi-sr-badge text-base flex items-center"></i>
            <Paragraph variant={"BodyCompact"}>83 914 571 673</Paragraph>
        </div>


        {/* <div className="flex items-center gap-5 text-offblack">
          <i className="fi fi-sr-phone-call text-base flex items-center"></i>
          <Paragraph variant={"BodyCompact"}>12 456 789 532</Paragraph>
        </div> */}
        {/* </div> */}
      </div>
      
      {/* Role, Location & Member Since Container */}
      <div className="bg-white rounded-xl py-5 px-8">
        <div className="flex flex-col gap-4">
          <div className="flex items-center gap-3 text-offblack">
            <i className="fi fi-sr-briefcase text-base flex items-center"></i>
            <Paragraph variant={"BodyCompact"}>Plumber</Paragraph>
          </div>
          <div className="flex items-center gap-3 text-offblack">
            <i className="fi fi-sr-shield-check text-base flex items-center"></i>
            <Paragraph variant={"BodyCompact"}>{displayPlan}</Paragraph>
          </div>
          <div className="flex items-center gap-3 text-offblack">
            <i className="fi fi-sr-marker text-base flex items-center"></i>
            <Paragraph variant={"BodyCompact"}>Melbourne, Victoria, 3030</Paragraph>
          </div>
          <div className="flex items-center gap-3 text-offblack">
            <i className="fi fi-sr-time-check text-base flex items-center"></i>
            <Paragraph variant={"BodyCompact"}>Member since 2025</Paragraph>
          </div>
        </div>
      </div>
    </div>
  );
}; 